<script lang="ts">
	import MeekoDesktopGui from './_components/meeko-desktop-gui.svelte';
	import Container from '$lib/components/ui/container/container.svelte';
</script>

<Container class="mb-12 gap-12 pt-0">
	<div class="flex w-full flex-col gap-3">
		<MeekoDesktopGui />
	</div>
</Container>
